export default __webpack_public_path__ + "static/media/commercial6.1d08e94a.PNG";